export default function useAuth() {
    const queryClient = ReactQuery.useQueryClient()
    const { data, isLoading, isSuccess } = ReactQuery.useQuery({
        queryKey: ['auth'],
        queryFn: () => storageGet('userWidgetData'),
        staleTime: Infinity,
        gcTime: Infinity,
    })

    React.useEffect(() => {
        const dispose = storageListen('userWidgetData', (data) => queryClient.setQueryData(['auth'], data))

        return () => {
            dispose()
        }
    }, [])

    return { 
        data, 
        isLoading,
        isLoaded: isSuccess,
        isLoggedIn: !!data && 'token' in data,
    }
}
